import React, { useEffect, useState } from 'react'
import { Form, Select } from 'antd';
import { useKaipiaolxListQuery } from '../../../store/DianShangYeWuApi';

function InvoiceTypeSelect(props) {
    const [list,setList] = useState();
    const {data, isSuccess} = useKaipiaolxListQuery({kplx_qy_id:props.qy_id});
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                const newArr = data.Result.map((item) => {
                    const {kplx_id,kplx_name }=item;
                    return item = {value:kplx_id,label:kplx_name,key:kplx_id}
                })
                setList(newArr)
            }
        }
    },[data,isSuccess])
    return (
        <Form.Item 
            label={props.label} 
            required={props.required}  
            style={props.formStyle}
            wrapperCol={props.wrapperCol}
        >
            <Form.Item name={props.name} noStyle >
                <Select
                    options={list} 
                    onChange={(_,f) => {
                        if(f){
                            props.onChange(f.value,f.label,)
                        }
                    }}
                    placeholder={props.placeholder}
                    style={props.style}
                    allowClear
                    onClear={props.onClear}
                    disabled={props.disabled}
                />                        
            </Form.Item>
        </Form.Item>
    )
}

export default InvoiceTypeSelect
